import type { Dictionary, Translation } from '@/i18n/types';

const ro = {
  skipLink: 'Sari la conținut',
  govBarOfficial: 'Un serviciu oficial al Guvernului Republicii Moldova',
  govBarMinistry: 'Ministerul Agriculturii și Industriei Alimentare',
  govBarAccessibility: 'Accesibilitate',
  langSwitchAria: 'Schimbă limba',
  brandAria: 'AKIS — cabinetul personal',
  zoneLabel: 'Cabinet personal',
  accountAria: 'Cont: {{name}}',
  logout: 'Ieșire',
  menuAria: 'Meniu',
  closeMenuAria: 'Închide meniul',
  sidebarNavAria: 'Navigare cabinet',
  administration: 'Administrare',
  footerTerms: 'Politica de utilizare a site-ului',
  footerPrivacy: 'Politica de confidențialitate',
  footerCookies: 'Politica de cookies',
  footerAccessibility: 'Declarație de accesibilitate',
  footerCopyright: '© 2026 Ministerul Agriculturii și Industriei Alimentare · Găzduit pe MCloud',
  pageTitleSuffix: 'Cabinet personal · AKIS',
  navOverview: 'Prezentare generală',
  navProfile: 'Profilul meu',
  navMyRequests: 'Cererile mele',
  navPublications: 'Rapoarte și publicații',
  pageSavedResources: 'Resurse salvate',
  navTrainings: 'Materiale de instruire',
  navFunding: 'Cereri de finanțare',
  navApplicationsRegister: 'Cereri de finanțare',
  navMyEvents: 'Evenimentele mele',
  navResearchOrg: 'Cercetare',
  navAdvisorProfile: 'Profil de consilier',
  navAdoptions: 'Adopții în practică',
  navProviderServices: 'Servicii de consiliere',
  navEvents: 'Evenimente',
  navTrainingAdmin: 'Formare profesională',
  adminNavApproval: 'Aprobare conținut',
  adminNavNews: 'Noutăți',
  adminNavPages: 'Pagini și politici',
  adminNavHome: 'Pagina de acasă',
  adminNavLibrary: 'Bibliotecă digitală',
  adminNavMapPoints: 'Puncte pe hartă',
  adminNavContact: 'Solicitări de contact',
  adminNavInstitutions: 'Instituții',
  adminNavUsers: 'Utilizatori',
  adminNavRoles: 'Roluri și drepturi',
  adminNavAuditLog: 'Jurnal audit',
  adminNavUsageStats: 'Statistici utilizare',
  adminNavAdvisoryReport: 'Raport servicii de consiliere',
  adminNavEventEvaluations: 'Evaluări evenimente',
  adminNavFunding: 'Finanțare',
  adminNavSupportAgencies: 'Agenții de sprijin',
  adminNavAdvisorValidation: 'Validare consilieri',
  adminNavForums: 'Forumuri și Q&A',
  navMyInstitution: 'Instituția mea de formare',
  navMyCommunity: 'Comunitatea mea',
  adminNavWorkflows: 'Fluxuri de lucru',
  adminNavConfig: 'Configurare sistem',
  adminNavBackup: 'Backup bază de date',
} as const;

const en = {
  skipLink: 'Skip to content',
  govBarOfficial: 'An official service of the Government of the Republic of Moldova',
  govBarMinistry: 'Ministry of Agriculture and Food Industry',
  govBarAccessibility: 'Accessibility',
  langSwitchAria: 'Switch language',
  brandAria: 'AKIS — personal account',
  zoneLabel: 'Personal account',
  accountAria: 'Account: {{name}}',
  logout: 'Sign out',
  menuAria: 'Menu',
  closeMenuAria: 'Close menu',
  sidebarNavAria: 'Personal account navigation',
  administration: 'Administration',
  footerTerms: 'Website terms of use',
  footerPrivacy: 'Privacy policy',
  footerCookies: 'Cookie policy',
  footerAccessibility: 'Accessibility statement',
  footerCopyright: '© 2026 Ministry of Agriculture and Food Industry · Hosted on MCloud',
  pageTitleSuffix: 'Personal account · AKIS',
  navOverview: 'Overview',
  navProfile: 'My profile',
  navMyRequests: 'My requests',
  navPublications: 'Reports and publications',
  pageSavedResources: 'Saved resources',
  navTrainings: 'Training materials',
  navFunding: 'Funding applications',
  navApplicationsRegister: 'Funding applications',
  navMyEvents: 'My events',
  navResearchOrg: 'Research',
  navAdvisorProfile: 'Adviser profile',
  navAdoptions: 'Adoption in practice',
  navProviderServices: 'Advisory services',
  navEvents: 'Events',
  navTrainingAdmin: 'Professional training',
  adminNavApproval: 'Content approval',
  adminNavNews: 'News',
  adminNavPages: 'Pages and policies',
  adminNavHome: 'Home page',
  adminNavLibrary: 'Digital library',
  adminNavMapPoints: 'Map points',
  adminNavContact: 'Contact requests',
  adminNavInstitutions: 'Institutions',
  adminNavUsers: 'Users',
  adminNavRoles: 'Roles and permissions',
  adminNavAuditLog: 'Audit log',
  adminNavUsageStats: 'Usage statistics',
  adminNavAdvisoryReport: 'Advisory services report',
  adminNavEventEvaluations: 'Event evaluations',
  adminNavFunding: 'Funding',
  adminNavSupportAgencies: 'Support agencies',
  adminNavAdvisorValidation: 'Adviser validation',
  adminNavForums: 'Forums and Q&A',
  navMyInstitution: 'My training institution',
  navMyCommunity: 'My community',
  adminNavWorkflows: 'Workflows',
  adminNavConfig: 'System configuration',
  adminNavBackup: 'Database backup',
} satisfies Translation<keyof typeof ro>;

export const appShell = { ro, en } satisfies Dictionary;

export type AppShellKey = keyof typeof ro;
